module.exports = __webpack_public_path__ + "static/img/4.fcfe777.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/4.png
// module id = dhif
// module chunks = 0